import React from 'react';
import { useNotificationStore } from './NotificationStore';
import { useAuthStore } from '../../store/authStore';
import { useNavigate } from 'react-router-dom';

const ICONS = {
  join_request: '👤',
  challenge: '🏆',
  streak_broken: '🔥',
  promoted_leader: '👑',
  promoted_vice: '👑',
  member_removed: '🚪',
  weekly_reminder: '⏰',
  request_approved: '✅',
  request_rejected: '❌',
  new_challenge: '🏆',
};

export default function NotificationDrawer() {
  const { isDrawerOpen, closeDrawer, notifications, markAllRead, markOneRead } = useNotificationStore();
  const { token } = useAuthStore();
  const navigate = useNavigate();

  if (!isDrawerOpen) return null;

  return (
    <>
      <div className="fixed inset-0 z-40 bg-black/20 backdrop-blur-sm" onClick={closeDrawer} />
      <div className="fixed inset-y-0 right-0 z-50 w-full md:w-80 glass border-l border-white/10 shadow-2xl flex flex-col animate-slide-left">
        <div className="p-4 border-b border-white/10 flex items-center justify-between">
          <h2 className="text-white font-bold text-lg heading">Notifications</h2>
          <button onClick={() => markAllRead(token)} className="text-amber-400 text-xs hover:underline">
            Mark all read
          </button>
        </div>
        <div className="flex-1 overflow-y-auto p-2 space-y-2">
          {notifications.length === 0 ? (
            <div className="flex flex-col items-center justify-center h-full text-white/40 space-y-2">
              <span className="text-4xl">📖</span>
              <p className="text-sm">All caught up!</p>
            </div>
          ) : (
            notifications.map(n => (
              <div 
                key={n.id} 
                className={`p-3 rounded-xl cursor-pointer transition-colors ${!n.isRead ? 'border-l-4 border-indigo-500 bg-white/5' : 'hover:bg-white/5'}`}
                onClick={() => {
                  markOneRead(n.id, token);
                  if (n.link) {
                    navigate(n.link);
                    closeDrawer();
                  }
                }}
              >
                <div className="flex items-start gap-3">
                  <span className="text-xl">{ICONS[n.type] || '🔔'}</span>
                  <div className="flex-1">
                    <p className="text-white font-semibold text-sm">{n.title}</p>
                    <p className="text-white/60 text-xs mt-1 leading-snug">{n.body}</p>
                  </div>
                </div>
              </div>
            ))
          )}
        </div>
      </div>
    </>
  );
}
